export default __webpack_public_path__ + "static/ps1-daf73bf5d4f0d68ee444587ed885e175.jpg";